import FrequencyQuestions from './FrequencyQuestions'

export default FrequencyQuestions
